import {MessageBase} from './message-base';
import {PublisherParameter} from '../DoraWidget/widget-base/data/publisher-parameter';
import {FixedSeriesInfo} from './data/fixed-series-info';
import {DataRow} from '../DoraData/data-row';

export class MessageRowsSelected  extends MessageBase<MessageRowsSelected> {
  private dataRows: DataRow[];
  private fixedSeriesInfos: FixedSeriesInfo[] = [];
  private publisherParameters: PublisherParameter[] = [];

  constructor(dataRows: DataRow[], fixedSeriesInfos: FixedSeriesInfo[] = [],  publisherParameters: PublisherParameter[] = []) {
    super(MessageRowsSelected);

    this.dataRows = dataRows;
    this.fixedSeriesInfos = fixedSeriesInfos;
    this.publisherParameters = publisherParameters;
  }

  public get DataRows(): DataRow[] {
    return this.dataRows;
  }
  get PublisherParameters(): PublisherParameter[] {
    return this.publisherParameters;
  }

  get FixedSeriesInfos(): FixedSeriesInfo[] {
    return this.fixedSeriesInfos;
  }
}
